// extracted by mini-css-extract-plugin
module.exports = {"TaskLogGrid":"TaskLogGridGroup_TaskLogGrid__1Lo-a","gridOverlay":"TaskLogGridGroup_gridOverlay__2k7vq","taskModal":"TaskLogGridGroup_taskModal__T0vej"};